const prefix = "NOMA";

export const LANGUAGE = `${prefix}_LANG`;
